import { Alert, Stack, StackProps, styled, Typography } from "@mui/material"
import { orange } from "@mui/material/colors";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import { useAuthContext } from "@/features/auth/contexts/auth-context";

const StyledAlert = styled(Alert)(({ theme }) => ({
    backgroundColor: orange[900],
    color: theme.palette.common.white,
    paddingTop: 0,
    paddingBottom: 0
}))

export default function HeaderLogo(props: StackProps) {
    const { authData } = useAuthContext();

    return <Stack {...props} direction="row" alignItems="center" gap={1} sx={{ display: { xs: "none", sm: "flex" }, ...props.sx }}>
        <img src={"/logo-header.svg"} />
        {authData?.organizacionNombre && (
            <StyledAlert icon={false}>
                <Stack direction="row" alignItems="center" gap={0.5}>
                    <CorporateFareIcon sx={{ fontSize: { xs: 12, sm: 14 }, color: "inherit", opacity: 0.85 }} />
                    <Typography variant="subtitle2" fontSize={{ xs: "0.6rem", sm: "0.8rem" }}>
                        {authData.organizacionNombre}
                    </Typography>
                </Stack>
            </StyledAlert>
        )}
    </Stack>
}
